import { useState } from 'react';
import { ErrorState, LoadingSkeleton, PageViewerControls } from '../../components/primitives.jsx';
import { useApi } from '../../lib/useApi.js';

function apiPath(href) {
  return String(href || '').replace(/^\/api/, '');
}

export function RelatedEvidencePreview({
  family,
  label,
  emptyLabel,
  initialItems = [],
  preview,
  renderItem,
}) {
  const [expanded, setExpanded] = useState(false);
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const pageResult = useApi(apiPath(preview?.viewAllHref), {
    query: { limit: pageSize, offset },
    skip: !expanded || !preview?.viewAllHref,
  });
  const page = pageResult.data?.data?.page;
  const items = expanded ? pageResult.data?.data?.items || [] : initialItems;
  const total = Number(preview?.total || initialItems.length);
  const included = Number(preview?.included ?? initialItems.length);

  return (
    <section aria-label={`${label} related evidence`}>
      <div className="row" style={{ justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
        <h3 className="card-title" style={{ marginTop: 0 }}>
          {label}
        </h3>
        <span className="muted" style={{ fontSize: '0.78rem' }}>
          {expanded ? `All ${total}` : `Previewing ${included} of ${total}`}
        </span>
      </div>
      {expanded && pageResult.loading ? (
        <LoadingSkeleton rows={3} />
      ) : expanded && pageResult.error ? (
        <ErrorState error={pageResult.error} />
      ) : items.length === 0 ? (
        <div className="muted">{emptyLabel}</div>
      ) : (
        <div className="muted">{items.map(renderItem)}</div>
      )}
      {preview?.truncated || expanded ? (
        <div style={{ marginTop: 10 }}>
          <button
            type="button"
            className="btn ghost sm"
            onClick={() => {
              setOffset(0);
              setExpanded((value) => !value);
            }}
          >
            {expanded ? 'Show preview' : `View all ${total} ${family}`}
          </button>
        </div>
      ) : null}
      {expanded && page ? (
        <PageViewerControls
          page={page}
          label={family}
          pageSize={pageSize}
          onOffsetChange={setOffset}
          onPageSizeChange={(nextSize) => {
            setPageSize(nextSize);
            setOffset(0);
          }}
        />
      ) : null}
    </section>
  );
}
